module.exports = __webpack_public_path__ + "static/media/ach-logo-bank.91ff0e60.webp";